import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyBootModule } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "MsalAuth"*/ './lazyIndex'),
    { name: 'MsalAuth' }
);

export const lazyCreateMsalInstance: LazyAction<
    typeof lazyIndex.createMsalInstance,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.createMsalInstance);

export const lazySignoutFromMsal: LazyAction<typeof lazyIndex.signoutFromMsal, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.signoutFromMsal);

export const lazyAcquireAccessTokenMsal: LazyAction<
    typeof lazyIndex.acquireAccessTokenMsal,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.acquireAccessTokenMsal);

export const lazyGetAuthTokenMsal: LazyAction<
    typeof lazyIndex.getAuthTokenMsal,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAuthTokenMsal);
export const lazyGetAnchorMailbox: LazyAction<
    typeof lazyIndex.getAnchorMailbox,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAnchorMailbox);
export const lazyGetAnchorMailboxFromMsalAccount: LazyAction<
    typeof lazyIndex.getAnchorMailboxFromMsalAccount,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAnchorMailboxFromMsalAccount);
export const lazyLoginUserMsal: LazyAction<typeof lazyIndex.loginUserMsal, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.loginUserMsal);

export const lazyExecuteMsalNestedAppAuthRequest: LazyAction<
    typeof lazyIndex.executeMsalNestedAppAuthRequest,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.executeMsalNestedAppAuthRequest);
export const lazyPrefetchMsalNestedAppAuthRequest: LazyAction<
    typeof lazyIndex.prefetchMsalNestedAppAuthRequest,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.prefetchMsalNestedAppAuthRequest);

export const lazyOnActivityTimeoutErrorForMSAL: LazyAction<
    typeof lazyIndex.onActivityTimeoutErrorForMSAL,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onActivityTimeoutErrorForMSAL);

export const lazySetIsSigninRequired: LazyAction<
    typeof lazyIndex.setIsSigninRequired,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setIsSigninRequired);

export const lazyOnFederatedLogout: LazyAction<
    typeof lazyIndex.onFederatedLogout,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onFederatedLogout);

export const lazyGetMsalIdTokenClaims: LazyAction<
    typeof lazyIndex.getMsalIdTokenClaims,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getMsalIdTokenClaims);
